// Back to top button functionality
import $ from 'jquery';

class Totop {
    constructor() {
        this.toTopButton = $("#back-to-top");
        this.events();
    }
    events() {
        this.toTopButton.on("click", () => {
            this.scrollToTop();
        });
    }
    scrollToTop() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
}
export default Totop;